export default __webpack_public_path__ + "static/media/arrow_down_black.d7e63ca8.svg";